<web-settings-breadcrumbs>
    <div class="breadcrumb-icon">
        <a (click)="onReset()">
            <img src="./assets/img/websites/lpc-back-icon.svg" class="first-breadcrumb-icon" alt="lpc-back-icon" />
        </a>
    </div>
    <div class="breadcrumb-text">
        <span>{{ "form_fields_settings" | translate }}</span>
    </div>
</web-settings-breadcrumbs>

<div class="panel-options-body overflow-wrapper">
    <div class="form form-with-0-margin">
        <sp-form-element-settings-signal
            [element]="element()"
            [elements]="elements()"
            [crmContactsVariablesList]="crmContactsVariablesList()"
            [isCrmDealsListDisabled]="true"
            [isAddressBookListDisabled]="true"
            [isShowProtectedList]="false"
            [isLoginEduForm]="true"
            [isFileTypeDisabled]="isFileTypeDisabled()"
            (valueChangeEvent)="onElementChange($event)"
        />
    </div>
</div>

<web-settings-footer (saveEvent)="onSave()" (cancelEvent)="onReset()" />
